import { validate, getCheckDigit } from 'rut.js'

export const isAValidRut = (value) => {
  if (!validate(value)) return false
  const [documentNumber, checkDigit] = value.split('-')
  const expectedCheckDigit = getCheckDigit(documentNumber)

  return checkDigit === expectedCheckDigit
}
